/* eslint-disable @typescript-eslint/no-empty-function */
import { Injectable } from '@angular/core';

import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataSubscriptionService {
  constructor(
  ) { }
  //defino aquí las suscripciones de varios temas que deben durar toda la sesión, como pacienteIndicesSuscrip
  //que leo una vez en inicio-com y no quiero cerrar al cerrar el componente. Esto reduce las lecturas
  //a Firebase y mejora el desempeño del sistema, porque son datos muy usados en el sistema.
  //Estas suscripciones deben cerrarse al terminar la sesión, o se mantendrán vivas entre sesiones 
  empAutSuscrip: Subscription;
  cfgVariasSuscrip: Subscription;
  textosPorProductoSuscrip: Subscription;
  temaActualSuscrip: Subscription;
  usersSuscrip: Subscription;   //todos los usrs
  userSuscrip: Subscription;    //solo el usr actual
  cfgDatosSRISuscrip: Subscription;
  pacienteIndicesSuscrip: Subscription;
  pacientesSuscrip: Subscription;
  //No cargo todas las citas una sola vez porque son demasiadas!
  //Voy cargando las que hagan falta
  //CitaIndicesSuscrip: Subscription;
  //CitasSuscrip: Subscription;
  arbitroEstadoSesionSuscrip: Subscription;
  articulosSuscrip: Subscription;
  atiendesSuscrip: Subscription;
  tiposRecetasSuscrip: Subscription;
  entDiagsSuscrip: Subscription;
  entProcsSuscrip: Subscription;
  entPressSuscrip: Subscription;
  entIndicsSuscrip: Subscription;
  onlineSuscrip: Subscription;
  planesSuscrip: Subscription;
  ultimoConsumoSuscrip: Subscription;

  cerrarSuscripcionesGlobales(): void {
    if (this.empAutSuscrip != undefined) { this.empAutSuscrip.unsubscribe(); }
    if (this.cfgVariasSuscrip != undefined) { this.cfgVariasSuscrip.unsubscribe(); }
    if (this.textosPorProductoSuscrip != undefined) { this.textosPorProductoSuscrip.unsubscribe(); }
    if (this.temaActualSuscrip != undefined) { this.temaActualSuscrip.unsubscribe(); }
    if (this.usersSuscrip != undefined) { this.usersSuscrip.unsubscribe(); }
    if (this.userSuscrip != undefined) { this.userSuscrip.unsubscribe(); }
    if (this.cfgDatosSRISuscrip != undefined) { this.cfgDatosSRISuscrip.unsubscribe(); }
    if (this.pacienteIndicesSuscrip != undefined) { this.pacienteIndicesSuscrip.unsubscribe(); }
    if (this.pacientesSuscrip != undefined) { this.pacientesSuscrip.unsubscribe(); }
    //this.CitaIndicesSuscrip.unsubscribe();
    //this.CitasSuscrip.unsubscribe();
    if (this.arbitroEstadoSesionSuscrip != undefined) { this.arbitroEstadoSesionSuscrip.unsubscribe(); }
    if (this.articulosSuscrip != undefined) { this.articulosSuscrip.unsubscribe(); }
    if (this.atiendesSuscrip != undefined) { this.atiendesSuscrip.unsubscribe(); }
    if (this.tiposRecetasSuscrip != undefined) { this.tiposRecetasSuscrip.unsubscribe(); }
    if (this.entDiagsSuscrip != undefined) { this.entDiagsSuscrip.unsubscribe(); }
    if (this.entProcsSuscrip != undefined) { this.entProcsSuscrip.unsubscribe(); }
    if (this.entPressSuscrip != undefined) { this.entPressSuscrip.unsubscribe(); }
    if (this.entIndicsSuscrip != undefined) { this.entIndicsSuscrip.unsubscribe(); }
    if (this.onlineSuscrip != undefined) { this.onlineSuscrip.unsubscribe(); }
    if (this.planesSuscrip != undefined) { this.planesSuscrip.unsubscribe(); }
    if (this.ultimoConsumoSuscrip != undefined) { this.ultimoConsumoSuscrip.unsubscribe(); }
  }
}
